class SelectionLocationHelper {
   static getContainerLocation(prefix, container) {
      return `${prefix}>${container.title}-${container.order}`
   }

   static getRelationshipLocation(prefix, relationship) {
      return `${prefix}>${relationship.code}`
   }

   static findLocation(prefix, container, location) {
      const thisLocation = this.getContainerLocation(prefix, container);
      if (thisLocation === location) {
         return container
      } else {
         let item = null;
         if (container.container.length) {
            container.container.some(c => {
               item = this.findLocation(thisLocation, c, location)
               return item
            })
         }

         if (!item && container.relationship.length) {
            container.relationship.some(r => {
               if (this.getRelationshipLocation(thisLocation, r) === location) {
                  item = r;
               }
               return item
            })
         }
         return item
      }
   }
}

export default SelectionLocationHelper
